import React from "react";
import { Link } from "react-router-dom"; 



function FooterTwo() {
  return (
    <footer className="footer">
    
      {/* 🌙 Bottom Section */}
      <div className="footer-bottom text-center">
        <p className="text-white p-0 m-0">
          © {new Date().getFullYear()} <strong>Soulsathi.com</strong> — All rights reserved.  
          Designed & Developed by{" "}
          <a href="https://ignsoftwares.in/" target="_blank" rel="dofollow" className="text-white">
            IGN SOFTWARES
          </a>
        </p>

        
      </div>
    </footer>
  );
}

export default FooterTwo;
